module.exports = "../content/1c7e1d37b9a631bc5b8244fc24ac080c.woff2";